import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function linkButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'linkButton',
    baseStyle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.primary,
      backgroundColor: theme.colors.hype.background80,
      borderRadius: '9999px',
      border: `solid 2px ${theme.colors.primary}`,

      ['&:hover']: {
        borderColor: theme.colors.border
      }
    },
    variants: {
      primary: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.hype.background80,
        fontSize: theme.sizes['0'],
        border: 'unset',

        ['&:hover']: {
          backgroundColor: theme.colors.hype.primaryHover,
          color: theme.colors.primary
        }
      }
    }
  };
}
